import React, { useEffect, useRef, useState } from 'react'
import axios from 'axios'
import {Baseurl} from '../../constants/env'
import './Shop.scss'
import { enqueueSnackbar } from 'notistack'
import {useNavigate, useSearchParams, useLocation} from 'react-router-dom'
import Button from 'react-bootstrap/esm/Button'
import Tempfooter from '../Tempfooter'
import QuillTextDisplay from '../common/QuillTextDisplay'
import RangeSliderInput from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';

const Shop = () => {
     const [data, setData] = useState([]);
     const [names, setNames] = useState([]);
     const [selectedName, setSelectedName] = useState([]);
     const [condition, setCondition] = useState([]);
     const [priceRange, setPriceRange] = useState([100, 100000]);
     const [minPrice, setMinPrice] = useState(100);
     const [maxPrice, setMaxPrice] = useState(100000); 
    const location = useLocation()
    const Navigate = useNavigate()
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [filter, setFilter] = useState('');
  const [filterChanged, setFilterChanged] = useState(false);
    const [searchParams] = useSearchParams();
    const searchTerm = searchParams.get('search')
    const brandterm = searchParams.get('brands');
    const categoryterm = searchParams.get('category');


    async function getprodutsdata() {
      const params = new URLSearchParams();
      if (searchTerm) { // Check if searchTerm is not null or undefined
        params.append('search', searchTerm); // Corrected typo: 'serach' to 'search'
      }
      if (condition && condition.length) {
        let cleanedCond = condition.filter(item => item !== null && item !== undefined);
        cleanedCond.forEach(cond => params.append('condition', cond)); 
      }
      if (selectedName && selectedName.length && !searchParams.get('brands')) {
        let cleanedNames = selectedName.filter(item => item !== null && item !== undefined);
        cleanedNames.forEach(brand => params.append('brand', brand));
      }

      if(searchParams.get('brands')){
        params.append('brand', brandterm)
      } 
    
      if (categoryterm) { 
        params.append('category', categoryterm);
      }
    
      if (minPrice || minPrice === 0) { 
        params.append('minPrice', minPrice || 0);
      }
    
      if (maxPrice) {
        params.append('maxPrice', maxPrice || 300000);
      }
      
      params.append('page', filterChanged ? 1 : currentPage );
      params.append('limit', 2 );
      if (filterChanged) {
        setCurrentPage(1);
        setFilterChanged(false);
      }
      await axios(`${Baseurl}/products?${params.toString()}`, {
        withCredentials: true,
      })
        .then((resp) => {
          console.log(resp,'resp');
          
          setData(resp.data.data);
          setTotalPages(resp.data.totalPages);
        })
        .catch((e) => {
          console.log(e.message);
          enqueueSnackbar("Something Failed", { variant: "error" });
        });
    }

    async function filterProduts() {
      setFilterChanged(true);
      await getprodutsdata()
      // let url
      // if( location?.search !== ""){
      //   url = `${Baseurl}/products?search=${searchTerm}&minprice=${minPrice}&maxprice=${maxPrice}&`
      // }else{
      //   url = `${Baseurl}/products?minprice=${minPrice}&maxprice=${maxPrice}&`
      // }
      // if (selectedName.length > 0) {
      //   url += selectedName.map((name) => `name=${encodeURIComponent(name)}`).join('&');
      // }

      // if (condition.length > 0) {
      //   if (url.length > 0) { 
      //     url += '&'; 
      // }
      // url += condition.map((name) => `condition=${encodeURIComponent(name)}`).join('&');      }
      
      // await axios(`${url}`, {
      //   withCredentials: true,
      // })
      //   .then((resp) => {
      //     setData(resp.data.data);
      //   })
      //   .catch((e) => {
      //     console.log(e.message);
      //     enqueueSnackbar("Something Failed", { variant: "error" });
      //   });
    }
    const handleNameChange = (event,item) => {
      const { value, checked } = event.target;
      setFilterChanged(true);
      if (checked) {
        setSelectedName((prevNames) => [...prevNames, value]);
      } else {
        setSelectedName((prevNames) => prevNames.filter((name) => name !== value));
      }
    };
    const handleConditionChange = (event) => {
      const { value, checked } = event.target;
      console.log(event,'event');
      setFilterChanged(true);
      let mappedValue;
  
      if (value === 'New') {
          mappedValue = '67d3997721d91ac853505b56';
      } else if (value === 'Refrubmished') {
          mappedValue = '67d3992621d91ac853505b55';
      } else {
          mappedValue = '67d398c821d91ac853505b54';
      }
  
      if (checked) {
          setCondition((prevConditions) => [...prevConditions, mappedValue]);
      } else {
          setCondition((prevConditions) => prevConditions.filter((name) => name !== mappedValue));
      }
    };

    const sampleArray = [
      {name:'New',type:'brandnew'},
      {name:'Refrubmished',type:'refurb'},
      {name:'Old',type:'old'}
    ]

    const fetchBrands = async () => {  
      let result = await axios(`${Baseurl}/brand`)
      if(brandterm){
      let data = result?.data?.data.filter(item => item._id === brandterm)
      setNames(data)
      return
      }
      setNames(result?.data?.data)
    };

    const handleMinPriceChange = (event) => {
      setMinPrice(parseInt(event.target.value));
    };
  
    const handleMaxPriceChange = (event) => {
      setMaxPrice(parseInt(event.target.value));
    };

    const detailPage = (id,category) => {
      return Navigate(`/prod/${id}`)
    }

    const [isGrid, setIsGrid] = useState(false);

    const toggleLayout = () => {
      setIsGrid(!isGrid);
    };

    const handlePageChange = (pageNumber) => {
      setCurrentPage(pageNumber);
      window.scrollTo(0, 0);
    };
  
    const handleFirstPage = () => {
      setCurrentPage(1);
      window.scrollTo(0, 0);
    };
  
    const handleLastPage = () => {
      setCurrentPage(totalPages);
      window.scrollTo(0, 0);
    };
  
    // Generate page numbers for pagination
    const getPageNumbers = () => {
      const pageNumbers = [];
      const maxPagesToShow = 5; // Show 5 page numbers at a time
      
      let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
      let endPage = startPage + maxPagesToShow - 1;
      
      if (endPage > totalPages) {
        endPage = totalPages;
        startPage = Math.max(1, endPage - maxPagesToShow + 1);
      }
      
      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
      }
      
      return pageNumbers;
    };
    const handleRangeChange = (range) => {
      console.log(range,'range');
      
      setPriceRange(range);
      setMinPrice(range[0])
      setMaxPrice(range[1])
    };

    useEffect(() => {
      (async () => {
        if(!searchParams.get('brands')){
          setFilterChanged(true);
          await getprodutsdata()
          await fetchBrands()
          return
        }
        await fetchBrands()
        }
      )()
    }, []);


    useEffect(() => {
      if(searchParams.get('brands')){
        setFilterChanged(true);
        setSelectedName((prevNames) => [...prevNames, brandterm]);
      }
     }, [brandterm]);

     useEffect(() => {
      (async () => {
        //setFilterChanged(true);
        await getprodutsdata()
        }
      )()
    }, [selectedName, condition, categoryterm, searchTerm, currentPage]); 

  
  
    





    // useEffect(() => {
    //   (async () => {
    //     if(searchParams.get('category')){
    //     await getprodutsdata()
    //     }
    //     }
    //   )()
    // }, [searchTerm]);

    // useEffect(() => {
    //   (async () => {
    //     if(!location?.search){
    //     await getprodutsdata()
    //     await fetchBrands()
    //     }
    //   })()
    // }, []);
    // useEffect(() => {
    //   (async () => {
    //     if(!location?.search){
    //       await filterProduts()
    //     }
    //   })()
    // }, [selectedName,condition]);

    // useEffect(() => {
    //   (async ()=> {
    //     if(location?.search !== ""){
    //       await axios(`${Baseurl}/products?search=${searchTerm}`, {
    //         withCredentials: true,
    //       }).then((resp) => {
    //         console.log(resp,'resp');
            
    //           setData(resp.data.data);
    //         })
    //         await fetchBrands()
    //     }
    //   })()
    // },[searchTerm])

    // useEffect(() => {
    //   (async () => {
    //     if(location?.search !== ""){
    //       await filterProduts()
    //     }
    //   })()
    // }, [selectedName,condition]);

  return (
    <>

<main className='main'>
<section className='section-inner-page'>
  
    
      <div className='container'>
      <div className='row'>
      <div className='col-sm-12'>
      <div class="col-md-12">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><a href="#">Home</a></li>
                <li className="breadcrumb-item active" aria-current="page">
                  shop
                </li>
              </ol>
            </nav>
          </div>
      </div>
      </div>



        <div className='row'>

       
          
         <div className='col-md-3 filter-sidebar'>
    <div>
    <details className='mt-2'>
      <summary><span className='fs-md-5'> Brands</span></summary>
      <div className='filter-items'>
      {names.map((item) => (
        <div className='form-check' key={item._id}>
          <label style={{ display: 'flex', alignItems: 'center' }}>
            <input
            className='form-check-input'
              type="checkbox"
              value={ item._id}
              disabled={searchParams.get('brands')}
              checked={selectedName.includes(item?._id)}
              onChange={(event) => {handleNameChange(event,item)}}
              style={{ marginRight: '8px' }}
            />
            {item.name}
          </label>
        </div>
      ))} </div>
    </details>

    <details className='mt-2'>
      <summary><span className='fs-md-5'>Select Condition</span></summary>
      <div className='form-check'>
      {sampleArray.map((item,index) => (
        <div key={index}>
          <label style={{ display: 'flex', alignItems: 'center' }}>
            <input
            className='form-check-input'
              type="checkbox"
              value={item.name}
              // checked={selectedCondition === item.name}
              onChange={handleConditionChange}
              style={{ marginRight: '8px' }}
            />
            {item.name}
          </label>
        </div>
      ))} </div>
    </details>

    <details className='mt-2'>
    <summary><span className='fs-md-5'>Select Price</span></summary>
    {/* <div>
        <label htmlFor="minPrice">Min Price: {minPrice}</label>
        <input
          type="range"
          id="minPrice"
          min="0"
          max={maxPrice} // Limit min to max
          value={minPrice}
          onChange={handleMinPriceChange}
        />
      </div> */}
      {/* <div>
        <label htmlFor="maxPrice">Max Price: {maxPrice}</label>
        <input
          type="range"
          id="maxPrice"
          min={minPrice} // Limit max to min
          max="300000" // Adjust as needed
          value={maxPrice}
          onChange={handleMaxPriceChange}
        />
      </div> */}
      <div className="card p-3 shadow-sm" style={{ maxWidth: '350px' }}>
      <h5 className="card-title mb-3">Price Range</h5>
      
      <div className="d-flex justify-content-between mb-2">
        <span className="badge bg-secondary">${minPrice}</span>
        <span className="badge bg-secondary">${maxPrice}</span>
      </div>
      
      <div className="px-2 mb-3">
        <RangeSliderInput
          min={100}
          max={100000}
          step={10}
          value={priceRange}
          onInput={handleRangeChange}
          className="range-slider"
        />
      </div>
      
      <div className="d-flex justify-content-between px-2">
        <small className="text-muted">$ {minPrice}</small>
        <small className="text-muted">$ {maxPrice}</small>
      </div>
      
      <div className="mt-3 d-grid gap-2">
        <Button className="btn btn-primary-theme me-2 w-auto btn btn-primary" onClick={filterProduts}>Apply Filter</Button>
      </div>
    </div>
      {/* <Button className='bg-secondary' onClick={filterProduts}>Apply Filter</Button> */}
    </details>



    </div>
        
         </div>
         <div className='col-md-9'>

          <div className='row mb-3'>
          <div className='col-md-12'>

          <div class="card p-3">

          <div class="row">
          <div class="col-md-6 d-flex align-items-center">
            <div>
           { data?.length ? <span>911 Items in <strong>Oven</strong> </span> : 'No Products'}
            </div>
            
</div>
<div className='col-md-6'>

  <div className='grid-list-tab'>
    <ul>
      <li>
        <a className= {`${isGrid ? '' :'active' }`}> 
        <button onClick={toggleLayout}>
        <i class="bi bi-grid"></i>
       </button> </a>
      </li> 
      <li>
        <a className= {`${isGrid ? 'active' :'' }`}> 
        <button onClick={toggleLayout}>
        <i class="bi bi-card-list"></i>
       </button>
        </a>
      </li>
    </ul>
  </div>


</div>


            </div>


            
 
</div>

          </div>
          </div>


   {/* Grid Start        */}
{/* <div class="row">
 
  <div class="col-md-4">

   <div class="product-box">

     <div class="project-image">

       <img src="/images/home/ovan.png" class="img-fluid"  />

     </div>

     <div class="product-details">
       <h4>
         DGNA Oven
       </h4>
<div>              <span class="price">AED 2000</span> <span class="crossed-price"> AED 2200</span>
</div>
<div class="ratings mb-2 mt-1"><img src="/images/icons/gold-star.svg" class="img-fluid " alt="image" /> <img src="/images/icons/gold-star.svg" class="img-fluid " alt="image" /> <img src="/images/icons/gold-star.svg" class="img-fluid " alt="image"/> <img src="/images/icons/gold-star.svg" class="img-fluid " alt="image"/> <img src="/images/icons/gold-star.svg" class="img-fluid me-2" alt="image"/> 4.2
</div>



     </div>



   </div>



 </div>
 <div class="col-md-4">

<div class="product-box">

  <div class="project-image">

    <img src="/images/home/ovan.png" class="img-fluid"  />

  </div>

  <div class="product-details">
    <h4>
      DGNA Oven
    </h4>
<div>              <span class="price">AED 2000</span> <span class="crossed-price"> AED 2200</span>
</div>
<div class="ratings mb-2 mt-1"><img src="/images/icons/gold-star.svg" class="img-fluid " alt="image" /> <img src="/images/icons/gold-star.svg" class="img-fluid " alt="image" /> <img src="/images/icons/gold-star.svg" class="img-fluid " alt="image"/> <img src="/images/icons/gold-star.svg" class="img-fluid " alt="image"/> <img src="/images/icons/gold-star.svg" class="img-fluid me-2" alt="image"/> 4.2
</div>



  </div>



</div>



</div>
<div class="col-md-4">

<div class="product-box">

  <div class="project-image">

    <img src="/images/home/ovan.png" class="img-fluid"  />

  </div>

  <div class="product-details">
    <h4>
      DGNA Oven
    </h4>
<div>              <span class="price">AED 2000</span> <span class="crossed-price"> AED 2200</span>
</div>
<div class="ratings mb-2 mt-1"><img src="/images/icons/gold-star.svg" class="img-fluid " alt="image" /> <img src="/images/icons/gold-star.svg" class="img-fluid " alt="image" /> <img src="/images/icons/gold-star.svg" class="img-fluid " alt="image"/> <img src="/images/icons/gold-star.svg" class="img-fluid " alt="image"/> <img src="/images/icons/gold-star.svg" class="img-fluid me-2" alt="image"/> 4.2
</div>



  </div>



</div>



</div> 
 



</div>  */}

   {/* Grid End        */}


      {/* list Start        */}



  
      <div class="col-md-12">



<div class="row">

{/* <div class="col-md-4">
<div class="project-image">

<img src="/images/home/ovan.png" class="img-fluid"  />

</div>

</div>

<div class="col-md-8">

<div class="product-details">
       <h4>
         DGNA Oven
       </h4>
<div>              <span class="price">AED 2000</span> <span class="crossed-price"> AED 2200</span>
</div>

<div className='mt-2 mb-3'>
<span class="ratings mb-2 mt-1"><img src="/images/icons/gold-star.svg" class="img-fluid " alt="image" /> <img src="/images/icons/gold-star.svg" class="img-fluid " alt="image" /> <img src="/images/icons/gold-star.svg" class="img-fluid " alt="image"/> <img src="/images/icons/gold-star.svg" class="img-fluid " alt="image"/> <img src="/images/icons/gold-star.svg" class="img-fluid me-2" alt="image"/> 4.2
</span> <span className='text-danger'>• </span>  <span className='text-muted'>154 Orders</span>   <span className='text-danger'>• </span>  <span className='text-success'>Free Shipping</span> 
</div>


<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
tempor incididunt ut labore et dolore magna aliqua</p>



     </div>



</div> */}



</div>





{/* <button onClick={toggleLayout}>
        Switch to {isGrid ? 'List' : 'Grid'} View
  </button> */}
<div className={isGrid ? 'grid-container w-75 h-50' : 'list-container'}>
{
  
  data?.map((item,index) => (
    <div class="product-box mb-3" key={index}>
    <button className="" onClick={()=>detailPage(item._id,item.category?.name)}>
    <div class="row" >

<div className={`${isGrid ? '' : 'col-md-4'}`} >
<div class="project-image">

<img  src={`${Baseurl}/view/imageupload/${item.img}`} class="img-fluid"  />

</div>

</div>

<div  className={`${isGrid ? 'text-start' : 'col-md-8'}`}>

<div class="product-details">
       <h4>
         {item?.name}
       </h4>
<div>  <span class="price">AED {item?.ourprice}</span> <span class="crossed-price"> AED {item?.mrpprice}</span>
</div>

<div className={ `mt-2 mb-3 ${isGrid ? 'text-start' : ''}`}>
<span class="ratings mb-2 mt-1">
{[...Array(5)].map((_, i) => (
  <i
    key={i}
    className={`bi bi-star-fill ${
      i < Math.round(item?.averageRating || 0)
        ? 'text-warning' 
        : 'bi-star text-secondary' 
    } me-2`} 
    style={{ fontSize: '1rem' }} 
  ></i>
))} 
{`${Number.isInteger(item?.averageRating) ? item?.averageRating + '.0' : item?.averageRating}`}
</span> 
{ isGrid ? <></>:
<span>
<span className='text-danger'>• </span> 
<span className='text-muted'>154 Orders</span>   
<span className='text-danger'>• </span>  
<span className='text-success'>Free Shipping</span> 
</span> }
</div>


{ isGrid ? <></>:<p className='text-start'> <QuillTextDisplay text={ item?.description?.slice(0,300) } /> </p> }
     </div>
</div>


</div> </button>   </div>
  ))
} </div>

 {/* <div className="container mt-5">
            <nav aria-label="Page navigation example">
                <ul className="pagination justify-content-center">
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>
                            Previous
                        </button>
                    </li>
                    {getPageNumbers().map((pageNumber) => (
                        <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}>
                            <button className="page-link" onClick={() => handlePageChange(pageNumber)}>
                                {pageNumber}
                            </button>
                        </li>
                    ))}
                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                        <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>
                            Next
                        </button>
                    </li>
                </ul>
            </nav>
        </div> */}

        <div className="container mt-4">
          {totalPages > 0 && (
            <nav aria-label="Page navigation">
              <ul className="pagination justify-content-center">
                {/* First Page Button */}
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <button 
                    className="page-link" 
                    onClick={handleFirstPage}
                    disabled={currentPage === 1}
                  >
                    First
                  </button>
                </li>
                
                {/* Previous Button */}
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <button 
                    className="page-link" 
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    &laquo;
                  </button>
                </li>
                
                {/* Page Numbers */}
                {getPageNumbers().map(number => (
                  <li 
                    key={number} 
                    className={`page-item ${currentPage === number ? 'active' : ''}`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(number)}
                    >
                      {number}
                    </button>
                  </li>
                ))}
                
                {/* Next Button */}
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                  <button 
                    className="page-link" 
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    &raquo;
                  </button>
                </li>
                
                {/* Last Page Button */}
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                  <button 
                    className="page-link" 
                    onClick={handleLastPage}
                    disabled={currentPage === totalPages}
                  >
                    Last
                  </button>
                </li>
              </ul>
            </nav>
          )}
    
    </div>
 
  {/* <div class="product-box mb-3">

<div class="row">

<div class="col-md-4">
<div class="project-image">

<img src="/images/home/ovan.png" class="img-fluid"  />

</div>

</div>

<div class="col-md-8">

<div class="product-details">
       <h4>
         DGNA Oven
       </h4>
<div>              <span class="price">AED 2000</span> <span class="crossed-price"> AED 2200</span>
</div>

<div className='mt-2 mb-3'>
<span class="ratings mb-2 mt-1"><img src="/images/icons/gold-star.svg" class="img-fluid " alt="image" /> <img src="/images/icons/gold-star.svg" class="img-fluid " alt="image" /> <img src="/images/icons/gold-star.svg" class="img-fluid " alt="image"/> <img src="/images/icons/gold-star.svg" class="img-fluid " alt="image"/> <img src="/images/icons/gold-star.svg" class="img-fluid me-2" alt="image"/> 4.2
</span> <span className='text-danger'>• </span>  <span className='text-muted'>154 Orders</span>   <span className='text-danger'>• </span>  <span className='text-success'>Free Shipping</span> 
</div>


<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
tempor incididunt ut labore et dolore magna aliqua</p>



     </div>



</div>



</div>





  </div> */}
  
  
  
  
  </div>

    
        </div>

   {/* list End        */}



{/* <div className='d-flex gap-3 flex-wrap  justify-content-center  align-items-center'>
  {
    data?.map((item,index) => {
      return (
     <div key={item._id}>
      <div className="card" style={{width: '15rem',height:'19rem'}}>
  <button className="" onClick={()=>detailPage(item._id,item.category.name)}>
    <div><img style={{width:'238px', height:'150px',borderRadius:'5px'}} src={`${Baseurl}/view/imageupload/${item.img}`}/></div>
    { item.type === 'old' ?<div className='border text-center p-1 bg-info'>OLD</div> :''}
    { item.type === 'refurb' ?<div className='border text-center p-1 bg-danger'>REFURBMISHED</div> :''}
    { item.type === 'brandnew' ?<div className='border text-center p-1 bg-success'>BRAND NEW</div> :''}
    <div style={{overflow:'hidden',textOverflow:'ellipsis'}} className='border text-center p-1 text-nowrap bg-light w-100'>{item.name}</div> 
    <div style={{overflow:'hidden',textOverflow:'ellipsis'}} className='border text-center pb-1 text-nowrap bg-light w-100'>{item.brand.name}</div> 
    <div style={{overflow:'hidden',textOverflow:'ellipsis'}} className='border text-center p-1 text-nowrap bg-light w-100'>{item.name}</div> 
    <div style={{overflow:'hidden',textOverflow:'ellipsis'}} className='border text-center  text-nowrap bg-light w-100 d-flex justify-content-center gap-1'>
    <span><del>{item.mrprice}</del></span> <span>{item.ourprice}</span></div> 

  </button>
</div>
        </div>
      )
    })
  }
</div> */}
         </div>

        </div>
        
      </section>
      <Tempfooter />
      </main>
    </>
  )
}

export default Shop
